import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

async function fetchCreditUsageData() {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/get-credit-usage`,
        {},
        { withCredentials: true }
      );
      const { data } = response;
      return data;
    } catch (error) {
      console.error("Error fetching credit usage:", error);
      return null;
    }
  }
  
const CreditContext = createContext();

export function CreditProvider({ children }) {
  const [creditData, setCreditData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await fetchCreditUsageData();
        setCreditData(data);
      } catch (err) {
        setError(err);
        console.error('Error loading credit data:', err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const refreshCreditData = async () => {
    setIsLoading(true);
    try {
      const data = await fetchCreditUsageData();
      setCreditData(data);
    } catch (err) {
      setError(err);
      console.error('Error refreshing credit data:', err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <CreditContext.Provider value={{ creditData, isLoading, error, refreshCreditData }}>
      {children}
    </CreditContext.Provider>
  );
}

export function useCreditData() {
  const context = useContext(CreditContext);
  if (context === undefined) {
    throw new Error('useCreditData must be used within a CreditProvider');
  }
  return context;
}
